/**
 * @ngdoc directive
 * @name WcResponsiveTableModule.directive:wcRowSelectHeaderCheckbox
 * @restrict E
 * @element div
 * @description
 * The wcRowSelectHeaderCheckbox directive is responsible for selecting the header in datatable on a checkbox click.
 */



angular.module('WcResponsiveTableModule')
	.directive('wcRowSelectHeaderCheckbox', ['$timeout', function ($timeout) {
		return {
			restrict: 'E',
			template: '<input type="checkbox" class="wc-header-checkbox" name="{{rowSelectHeaderCheckboxController.id}}-header-checkbox" ng-change="rowSelectHeaderCheckboxController.selectAllRows()" ng-model="rowSelectHeaderCheckboxController.isChecked">',
			require: ['wcRowSelectHeaderCheckbox', '^wcResponsiveTable', '^ngModel'],
            scope: {},
            bindToController: {
                wcRowSelectHeaderCheckbox: '@'
            },
			controllerAs: 'rowSelectHeaderCheckboxController',
			controller: ['$scope', '$element', function ($scope, $element) {
				var responsiveTableController = $element.parent().controller('wcResponsiveTable');
				var tableScope = responsiveTableController.WcTableScopeService.getTableScope();

                this.id = responsiveTableController.id;
				this.checkbox = $element.find('input');

				this.checkIfAllChecked = function () {
					var allCheckboxes = responsiveTableController.table.find('tbody input[type="checkbox"]');
					for (var i = 0; i < allCheckboxes.length; i++) {
						if (!angular.element(allCheckboxes[i]).is(':checked')) {
							this.isChecked = false;
							break;
						}
					}
				};

				this.selectAllRows = function () {
					var event = this.isChecked ? 'table.select.checkbox.all' : 'table.select.checkbox.none';
					tableScope.$broadcast(event);
				};

				tableScope.$watch(function () {
					return responsiveTableController.ngModel;
				}, angular.bind(this, function () {
					this.checkIfAllChecked();
				}));

				tableScope.$on('table.render.complete', angular.bind(this, function () {
					$timeout(angular.bind(this, function () {
						this.isChecked = true;
						this.checkIfAllChecked();
					}));
				}));
			}]
		};
	}]);